import { general } from './general';

export const checkboxgroup = (data = {}) => general('checkboxgroup', (data || {}));
